import { render, staticRenderFns } from "./OnboardingThankYou.vue?vue&type=template&id=75cdc274&lang=pug"
import script from "./OnboardingThankYou.vue?vue&type=script&lang=js"
export * from "./OnboardingThankYou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports